import '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import '../core/core-utils.js';
import '../core/parser.js';
import { compose } from '../core/compose.js';
import '../core/style-function.js';
import '../core/system.js';
import { margin } from './margin.js';
import { padding } from './padding.js';

const space = compose(margin, padding);

export { space };
